(() => {
  const initAnnouncementRotator = (root) => {
    if (!root || root.dataset.announcementRotatorReady === 'true') return;
    const messages = [...root.querySelectorAll('[data-announcement-message]')];
    if (messages.length < 2) return;
    root.dataset.announcementRotatorReady = 'true';
    let current = 0;
    const show = (index) => {
      messages.forEach((message, messageIndex) => {
        const active = messageIndex === index;
        message.classList.toggle('is-active', active);
        message.setAttribute('aria-hidden', String(!active));
      });
      current = index;
    };
    show(0);
    const timer = window.setInterval(() => {
      if (!root.isConnected) return window.clearInterval(timer);
      show((current + 1) % messages.length);
    }, 5000);
  };

  const initAnnouncementRotators = (scope = document) => {
    if (scope.matches?.('[data-announcement-rotator]')) initAnnouncementRotator(scope);
    scope.querySelectorAll?.('[data-announcement-rotator]').forEach(initAnnouncementRotator);
  };

  initAnnouncementRotators();
  document.addEventListener('shopify:section:load', (event) => initAnnouncementRotators(event.target));
})();

(() => {
  const header = document.querySelector('[data-header-mega]');
  if (!header) return;

  const mobileMenu = header.querySelector('[data-mobile-menu]');
  const mobileOverlay = header.querySelector('[data-mobile-menu-overlay]');
  const openButton = header.querySelector('[data-mobile-menu-open]');
  const closeButton = header.querySelector('[data-mobile-menu-close]');
  let lastFocusedElement;

  const usLocalization = header.querySelector('[data-us-localization]');
  if (usLocalization?.dataset.currentCountry && usLocalization.dataset.currentCountry !== 'US') {
    setTimeout(() => {
      try { usLocalization.submit(); } catch (error) { console.warn('Unable to switch to the US market', error); }
    }, 0);
  }

  const closeMegaMenus = (except) => {
    header.querySelectorAll('.header-mega__nav-item.is-open').forEach((item) => {
      if (item === except) return;
      item.classList.remove('is-open');
      item.querySelector('[data-mega-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  };

  header.querySelectorAll('[data-mega-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const item = toggle.closest('.header-mega__nav-item');
      item.classList.remove('is-escape-closed');
      const willOpen = !item.classList.contains('is-open');
      closeMegaMenus(item);
      item.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', String(willOpen));
    });
  });

  const setMobileMenu = (open) => {
    if (!mobileMenu) return;
    if (open) lastFocusedElement = document.activeElement;
    mobileMenu.classList.toggle('is-open', open);
    mobileOverlay?.classList.toggle('is-open', open);
    mobileMenu.setAttribute('aria-hidden', String(!open));
    openButton?.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
    document.body.classList.toggle('mobile-menu-open', open);
    if (open) closeButton?.focus();
    else lastFocusedElement?.focus();
  };

  openButton?.addEventListener('click', () => setMobileMenu(true));
  closeButton?.addEventListener('click', () => setMobileMenu(false));
  mobileOverlay?.addEventListener('click', () => setMobileMenu(false));
  mobileMenu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMobileMenu(false)));

  mobileMenu?.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab' || !mobileMenu.classList.contains('is-open')) return;
    const focusable = [...mobileMenu.querySelectorAll('a, button, input, select, [tabindex]:not([tabindex="-1"])')]
      .filter((element) => !element.hidden && element.getClientRects().length);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  header.querySelectorAll('[data-mobile-submenu-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      if (submenu) submenu.hidden = !open;
    });
  });

  // A parent/group item (Occasions, Recipients, Product, ...) points at /collections/all only as a
  // fallback; on mobile, tapping it should open its submenu so the shopper reaches the real category
  // pages instead of the unfiltered all-products page. Falls back to the link when JS is unavailable.
  header.querySelectorAll('[data-mobile-parent-link]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const toggle = link.closest('.header-mega__mobile-row')?.querySelector('[data-mobile-submenu-toggle]');
      if (toggle) {
        event.preventDefault();
        toggle.click();
      }
    });
  });

  header.querySelectorAll('[data-localization-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.header-mega__nav-item')) closeMegaMenus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openItem = header.querySelector('.header-mega__nav-item.is-open, .header-mega__nav-item:focus-within');
    const openToggle = openItem?.querySelector('[data-mega-toggle]');
    openItem?.classList.add('is-escape-closed');
    closeMegaMenus();
    openToggle?.setAttribute('aria-expanded', 'false');
    openToggle?.focus();
    if (mobileMenu?.classList.contains('is-open')) setMobileMenu(false);
  });
})();
